import React, {useContext} from 'react';
import newChat from "../../../assets/newChat.svg";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import {GlobalContext} from "../../../App.tsx";

interface NewChatButtonProps {}

const NewChatButton: React.FC<NewChatButtonProps> = ({ }) => {
    const { resetStateHelper } = useContext(GlobalContext);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { canSubmit } = dynamicStateObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const handleNewChatClick = async () => {
        await resetStateHelper();
        setDynamicStateObj({isMenuOpen: false});
    };

    return (
        <button
            className={`${environment.includes("jetbrains") || environment === "chrome" ? 'mr-auto ml-4' : 'ml-auto mr-4'} ${!canSubmit ? 'opacity-30 cursor-default' : ''}`}
            onClick={handleNewChatClick}
            disabled={!canSubmit}
        >
            <img src={`${newChat}`} className="h-6 w-6 invert dark:invert-0" alt="New Chat" />
        </button>
    );
};

export default NewChatButton;
